// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"214":"2eb7ac18","453":"1b811330","756":"845f6c8b"}[chunkId] + ".chunk.js";
};